import { render, staticRenderFns } from "./PrimaryCodeManagement.vue?vue&type=template&id=2c5ebb59&scoped=true&"
import script from "./PrimaryCodeManagement.vue?vue&type=script&lang=ts&"
export * from "./PrimaryCodeManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryCodeManagement.vue?vue&type=style&index=0&id=2c5ebb59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ebb59",
  null
  
)

export default component.exports